import { ReactNode } from 'react';
import useQRCodeRedirect from '../../shared/hooks/useQRCodeRedirect';

interface MainLayoutOutletProps {
    children: ReactNode;
}

const MainLayoutOutlet = ({ children }: MainLayoutOutletProps) => {
    const { companyId }  = useQRCodeRedirect();
    return (
        <div className="main-layout">
            <div className="main-layout-content">
                {children}
            </div>
        </div>
    );
};

export default MainLayoutOutlet;